// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

// #####################################################

const DataName = () => {
	const { t } = useTranslation(["common", "userProfile"]);

	const partnersName = useSelector(
		(state) => state.userProfileMain.partners.name,
	);

	// #####################################################

	return (
		partnersName.filter((item) => item).length !== 0 && (
			<Block>
				<Text mr={1}>{t("userProfile:name")}:</Text>
				<Text
					bold
					style={{
						wordBreak: "break-word",
					}}
				>
					{partnersName
						.filter((item) => item !== null)
						.join(` ${t("common:and")} `)}
				</Text>
			</Block>
		)
	);
};

// #####################################################

export default DataName;

// #####################################################
